export default {
    title: 'default',

    colors: {
        primary: '#e7ecef',
        secondary: '#a9acae',
        effect: "#d8a47f",
        background: '#202229',
        backgroundSecondary: '#24262e',
        text: '#f4f4f4'
    }
}